import SecondServer from '../database/SecondServer'
import { urlRequest} from '../database/apiUrls';

export async function GrantRequests (props, ss=undefined) {
  if (!ss)
    ss = new SecondServer (props)
  return coreGrantReq(ss)
    .then ((resp)=> tuserFilter(props, resp))
    .catch((e) => ({req: undefined, err:e.toString()}))
}
function tuserFilter (props, requests) {
  return (Array.isArray(requests) && props.userLogin === 'tuser') ?
    {req: requests.filter(i=> i?.rbcTarget === 'hostDb_Tehama'), err:null} :
    {req: requests, err:null}
}
async function coreGrantReq(ss) {
  return ss.apiData(urlRequest())
    .then ((resp) => resp?.data?.data?.grantRequests)
    .catch((e) => e)
}
